<template>
  <v-container>
    <v-row class="text-center">

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Tracking
        </h1>

        <p class="subheading font-weight-regular">
          Insert here your tracking number
        </p>
        <v-text-field
            v-model="trackid"
            label="tracking number"
            clearable
         ></v-text-field>
      </v-col>

      <v-col
        class="mb-5"
        cols="12"
      >

        <v-row justify="center">
          <v-btn @click="carica()">Load</v-btn>
        </v-row>
      </v-col>

      <v-col v-if="loading" 
              class="mb-5"
        cols="12">
          <v-progress-circular
            indeterminate
            color="orange"
          ></v-progress-circular>
      </v-col>
      <v-col v-if="info.result[0].status.length>0"
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Your shipment
        </h2>

        <v-row justify="center">
            <v-timeline reverse>
              <v-timeline-item 
                color="orange"
                v-for="step in info.result[0].status" 
                :key = "step.Date" >{{i}} {{step.Date}} <br> {{step.NameEng}} <br> {{step.NameRu}}</v-timeline-item>
            </v-timeline>
        </v-row>
        
      </v-col>


    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',
//CHGP0000002492
    data: () => ({
      info:{"result":[{"id":"'","track":"","orderNum":"","shipmentNum":"","status":[]}],"error":{"isError":false}},
      ecosystem: [      ],
      importantLinks: [],
      whatsNext: [],
      loading:false
    }),
    methods: {
      carica(){
        this.loading = true;
       var url ="https://us-central1-secom-tracking.cloudfunctions.net/api/v1/gettracking?t="+this.trackid;
       var config = {
          headers: {'Access-Control-Allow-Origin': '*'}
      };
      console.log(url);
      this.axios
      .get(url,config)
      .then(response => {
        console.log(response)
        this.info = response.data.message
        this.loading = false;
        })
      .catch(err => {
            console.log(err);
            this.loading = false;
        })
      }

    },
  }
</script>
